

$(function(){

	$(".baby-navi li").on("click", function() {
    $(".active").removeClass("active");
    $(this).addClass("active");
    const index = $(".baby-navi li").index(this);
    $(".baby-pict").hide();
		$(".baby-pict").eq(index).fadeIn(300);
  });

	$(".gnav-toggle").on("click", function() {
    if ($(this).hasClass("toggle-on")) {
      $(this).stop().removeClass("toggle-on");
      $("body").stop().removeClass("opacity_on");
      setTimeout(function(){
        $("body").stop().removeClass("menu_on");
        $("body").stop().removeClass("anime_on");
      },400);
    } else {
      $(this).stop().addClass("toggle-on");
      $("body").stop().addClass("menu_on");
      $("body").stop().addClass("opacity_on");
      $("body").stop().addClass("anime_on");
    }
  });

	$("#gnav-menu-body a").on("click", function() {
		$(".gnav-toggle").click();
	});

	$('.pagetop').hide();

	$(window).on("scroll", function() {

		if ($(this).scrollTop() > 300) {
			$('.pagetop').slideDown("fast");
		} else {
			$('.pagetop').slideUp("fast");
		}

		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		footHeight = $(".footer").innerHeight();

		if ( scrollHeight - scrollPosition  <= footHeight ) {
			$(".pagetop").css({
				"position":"absolute",
				"bottom": footHeight
			});
		} else {
			$(".pagetop").css({
				"position":"fixed",
				"bottom": "0"
			});
		}

		var Ptop = $("#assembly").offset().top;
		if ( $(this).scrollTop() < Ptop ) {
			$('.bnr-white-cv-bottom').fadeIn("fast");
		} else {
			$('.bnr-white-cv-bottom').fadeOut("fast");
		}

	});

	$('.pagetop').click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 400);
		return false;
	});


});
